import { GANGSTABET_PRODUCT } from "@constants/images";
import Button from "@components/common/Button.component";

const GbetToken = () => {
  return (
    <div className="gbetToken-wrapper">
      <div className="gbetToken">
        <div className="gbetToken-info">
          <h4 className="gbetToken-heading">GBET Token</h4>
          <p className="gbetToken-paragraph">
            GangstaBet Token ($GBET) is the native utility token of GangstaBet
            that is based on the IRC-2 standard of ICON Network which is similar
            to ERC20 in Ethereum. $GBET has utilities that will be burned (used)
            while changing the name of owned NFT, upgrading skills, and creating
            the stories for your GangstaBet NFTs ( new update released).
            GangstaBet owners earn $GBET on the daily basis till 2030 by just
            holding the NFT.
          </p>
          <Button onClick={() => window.open("https://docs.gangstabet.io/gangstaverse/gbet-token")}>learn more</Button>
        </div>
        <div className="spinner-wrapper">
          <img
            className="spinner"
            src={GANGSTABET_PRODUCT.SPINNER}
            alt="gbet logo"
          />
          <img
            className="gbet"
            src={GANGSTABET_PRODUCT.HAT}
            alt="gbet logo"
          />
        </div>
      </div>
    </div>
  );
};

export default GbetToken;
